import * as React from 'react';
import { useCallback, useEffect, useRef } from 'react';
import { GetAlerts, GetAlertsPaginated, GetUsers, CreateAlerts } from '../../REST/alert'
import DefaultSettings from '../../Utils/settings';
import { GetList, GetById } from '../../REST/crud';
import axios from 'axios';
import config from '../../config';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import AddIcon from '@mui/icons-material/Add';
import DetailsView from './details'
import Access from '../../Utils/authorize';
import Paper from '@mui/material/Paper';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom'
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDialog from '../../themes/components/ResponsiveDialog';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';

const SlideUp = React.forwardRef(function SlideUp(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function MessageDialog({ open, handleClose }) {
    const [type, setType] = React.useState('')
    const [items, setItems] = React.useState([]);
    const [select, setSelect] = React.useState([]); // Array of selected user objects
    const [subject, setSubject] = React.useState('')
    const [body, setBody] = React.useState('')
    const [templates, setTemplates] = React.useState([]);
    const [templateId, setTemplateId] = React.useState('');
    const [rawTemplate, setRawTemplate] = React.useState('');
    const [detectedVars, setDetectedVars] = React.useState([]);
    const [variableValues, setVariableValues] = React.useState({});
    const editorRef = useRef(null);
    const [selectAll, setSelectAll] = React.useState(false);
    const [selectAllGlobal, setSelectAllGlobal] = React.useState(false);
    // Convert SFDT JSON to HTML
    const convertSfdtToHtml = async (sfdtJson) => {
        try {
            const response = await axios.post(
                `${config.REACT_APP_TEMPLATE_URL}/API/documenteditor/HTML`,
                { sfdt: sfdtJson, groups: [] }
            );
            return response.data || '';
        } catch (err) {
            console.error('Failed to convert SFDT to HTML:', err);
            return '<p><strong>Error:</strong> SFDT conversion failed. Please try again or use an HTML template.</p>';
        }
    };

    const extractVariables = (html) => {
        const regex = /\{\{(\w+)\}\}/g;
        const vars = [];
        const seen = new Set();
        let match;
        while ((match = regex.exec(html)) !== null) {
            if (!seen.has(match[1])) { seen.add(match[1]); vars.push(match[1]); }
        }
        return vars;
    };

    // Substitute variables in template
    const substituteVars = (html, values) => {
        let result = html;
        Object.entries(values).forEach(([key, val]) => {
            result = result.split(`{{${key}}}`).join(val || `{{${key}}}`);
        });
        return result;
    };

    // Extract body content from full HTML document
    const extractBodyContent = (html) => {
        if (!html) return '';
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) return bodyMatch[1].trim();
        return html;
    };
    const SELECT_ALL_OPTION = {
    _id: '__select_all__',
    email: 'SELECT ALL',
    isSelectAll: true
};

const getOptionValue = (option) => {
    if (!option) return '';
    if (typeof option === 'string') return option;
    return option._id || option.id || option.email || '';
};

const getOptionLabelText = (option) => {
    if (!option) return '';

    if (typeof option === 'string') {
        return option;
    }

    if (option.isSelectAll) {
        return 'SELECT ALL';
    }

    let label = option.name || option.email || '';

    if (option.company) {
        label += ` | ${option.company}`;
    }

    return label;
};

const isAllSelected =
    items.length > 0 &&
    items.every(item =>
        select.some(selectedItem => getOptionValue(selectedItem) === getOptionValue(item))
    );

const handleAutocompleteChange = (event, newValue, reason, details) => {
    const clickedOption = details?.option;

    if (clickedOption?.isSelectAll) {
        if (isAllSelected) {
            setSelect([]);
            setSelectAll(false);
        } else {
            setSelect(items);
            setSelectAll(true);
        }
        return;
    }

    const cleanValue = newValue.filter(item => !item?.isSelectAll);

    setSelect(cleanValue);
    setSelectAll(cleanValue.length === items.length && items.length > 0);
};
    // Wrap HTML fragment in proper document structure for email
    const wrapForEmail = (html) => {
        if (!html) return html;
        if (html.includes('<!DOCTYPE') || html.includes('<html')) return html;
        return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body>
${html}
</body>
</html>`;
    };

    // Load master message templates when dialog opens
    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                // Load Custom (MessageTemplate) only — Standard (HtmlTemplate) are backend-only
                const msgResp = await GetList('MessageTemplate', { limit: 100 });
                const msgData = (msgResp.data?.data || msgResp.data || []).map(t => ({ ...t, _type: 'MessageTemplate' }));
                setTemplates(msgData);
            } catch (err) {
                console.error('Failed to load message templates', err);
            }
        })();
    }, [open]);

    // Reset form when dialog closes
    useEffect(() => {
        if (!open) {
            setTemplateId('');
            setSubject('');
            setBody('');
            setRawTemplate('');
            setDetectedVars([]);
            setVariableValues({});
            setSelect([]);
        }
    }, [open]);

    // Keep contentEditable div in sync when body is replaced programmatically (template pick)
    useEffect(() => {
        if (editorRef.current && editorRef.current.innerHTML !== body) {
            editorRef.current.innerHTML = body || '';
        }
    }, [body]);

    // Handle template selection change
    const handleTemplateChange = async (event) => {
        const id = event.target.value;
        setTemplateId(id);
        if (!id) {
            setSubject('');
            setBody('');
            setRawTemplate('');
            setDetectedVars([]);
            setVariableValues({});
            return;
        }

        const tmplMeta = templates.find(t => t._id === id);
        if (!tmplMeta) return;

        setSubject(tmplMeta.subject || '');

        // Fetch full template on demand to avoid loading heavy HTML for every template
        let fullTemplate = null;
        try {
            const apiType = tmplMeta._type || 'MessageTemplate';
            const resp = await GetById(apiType, id);
            fullTemplate = resp?.data || resp;
        } catch (err) {
            console.error('Failed to load full template:', err);
        }

        let htmlContent = '';
        const tmpl = fullTemplate || tmplMeta;

        // Priority: use content field if available (HTML templates)
        if (tmpl.content && tmpl.content.trim()) {
            htmlContent = tmpl.content;
        } else if (tmpl.sfdtTemplate && tmpl.sfdtTemplate.trim()) {
            htmlContent = await convertSfdtToHtml(tmpl.sfdtTemplate);
        } else {
            htmlContent = '<p>Template content is empty.</p>';
        }

        // If the template looks like SFDT JSON (object or string), convert it to HTML
        try {
            const looksLikeSfdt = (typeof htmlContent === 'string' && /"sections"\s*:\s*\[/.test(htmlContent)) || (typeof htmlContent === 'object' && htmlContent.sections);
            if (looksLikeSfdt) {
                let sfdtPayload = htmlContent;
                if (typeof htmlContent === 'string') {
                    try { sfdtPayload = JSON.parse(htmlContent); } catch (e) { /* keep as string */ }
                }
                const converted = await convertSfdtToHtml(sfdtPayload);
                htmlContent = converted || htmlContent;
            }
        } catch (e) {
            console.error('SFDT detection/conversion error', e);
        }

        // Extract body content if it's a full HTML document
        htmlContent = extractBodyContent(htmlContent);

        setRawTemplate(htmlContent);
        const vars = extractVariables(htmlContent);
        setDetectedVars(vars);

        const initialValues = Object.fromEntries(vars.map(v => [v, '']));
        setVariableValues(initialValues);

        setBody(htmlContent);
    };

    // Send handler
    const handleSend = () => {
        const emailHtml = wrapForEmail(body);
        // Resolve selected items to account _id values when possible.
        const recipientIds = select.map(u => {
            if (!u) return u;
            if (typeof u === 'string') {
                // try to find matching item by email
                const found = items.find(x => x.email === u || x._id === u);
                return found ? found._id : u;
            }
            return u._id || u.id || u.email || u;
        });
        CreateAlerts({ userIds: recipientIds, subject, body: emailHtml }).then(resp => {
            DefaultSettings.showAlert('The alert sent successfully', 'success');
            handleClose()
        }).catch(err => {
            DefaultSettings.showAlert('Failed to send notification', 'error');})
    }

    const handleVarChange = (varName, value) => {
        const newValues = { ...variableValues, [varName]: value };
        setVariableValues(newValues);
        if (rawTemplate) {
            setBody(substituteVars(rawTemplate, newValues));
        }
    };

    const handleEditorInput = () => {
        if (editorRef.current) {
            setBody(editorRef.current.innerHTML);
        }
    };

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelect(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleType = (event, value) => {
    if (!value) return;

    GetUsers(value).then(resp => {
        const list = resp.data || resp;

        setType(value);
        setItems(Array.isArray(list) ? list : []);
        setSelect([]);
        setSelectAll(false);
        setSelectAllGlobal(false);
    }).catch(err => console.log(err));
};

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={SlideUp}>
            {/* Full-screen AppBar with Cancel / Send */}
            <AppBar sx={{ position: 'relative', bgcolor: '#673ab7' }} elevation={1}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
                        Send a Message
                    </Typography>
                    <Button
                        color="inherit"
                        startIcon={<SendIcon />}
                        onClick={handleSend}
                        sx={{ color: '#fff' }}
                    >
                        Send
                    </Button>
                </Toolbar>
            </AppBar>

            <DialogContent>
                <DialogContentText>
                    <ToggleButtonGroup
                        color="primary"
                        value={type}
                        exclusive
                        onChange={handleType}
                        fullWidth
                    >
                        <ToggleButton value="ALL">All Users</ToggleButton>
                        <ToggleButton value="COMPANIES">Companies</ToggleButton>
                        <ToggleButton value="ACTIVE">Active Companies</ToggleButton>
                        <ToggleButton value="INTERNAL">Internal Users</ToggleButton>
                        <ToggleButton value="APPLICANTS">All Applicants</ToggleButton>
                        <ToggleButton value="NONE">Select User</ToggleButton>
                    </ToggleButtonGroup>
        
                    <Autocomplete
    multiple
    disableCloseOnSelect
    options={[SELECT_ALL_OPTION, ...items]}
    getOptionLabel={getOptionLabelText}
    value={select}
    onChange={handleAutocompleteChange}
    onInputChange={(event, value, reason) => {
        if (reason === 'reset' || reason === 'clear') return;

        if (typeof value === 'string' && value.trim().length > 0) {
            GetUsers(value)
                .then(resp => {
                    const list = resp.data || resp;
                    setItems(Array.isArray(list) ? list : []);
                })
                .catch(() => {});
        }
    }}
    isOptionEqualToValue={(option, value) => {
        return getOptionValue(option) === getOptionValue(value);
    }}
    renderOption={(props, option, { selected }) => {
        const isSelectAllOption = option.isSelectAll;

        return (
            <li
                {...props}
                key={getOptionValue(option)}
                style={{
                    ...props.style,
                    fontWeight: isSelectAllOption ? 700 : 400,
                    borderBottom: isSelectAllOption ? '1px solid #e0e0e0' : 'none',
                    backgroundColor: isSelectAllOption ? '#faf7ff' : props.style?.backgroundColor
                }}
            >
                <Checkbox
                    style={{ marginRight: 8 }}
                    checked={isSelectAllOption ? isAllSelected : selected}
                    indeterminate={
                        isSelectAllOption &&
                        select.length > 0 &&
                        select.length < items.length
                    }
                />

                {isSelectAllOption
                    ? `SELECT ALL ${type ? `(${type})` : ''}`
                    : getOptionLabelText(option)}
            </li>
        );
    }}
    renderInput={(params) => (
        <TextField
            {...params}
            label="Select Users"
            margin="dense"
            fullWidth
            helperText={
                items.length > 0
                    ? `${select.length} of ${items.length} selected`
                    : ''
            }
        />
    )}
    sx={{ mt: 2, mb: 2 }}
/>

                    <FormControl fullWidth margin='dense' sx={{ mt: 2 }}>
                        <InputLabel id='template-select-label'>Use Master Template</InputLabel>
                        <Select
                            labelId='template-select-label'
                            value={templateId}
                            label='Use Master Template'
                            onChange={handleTemplateChange}
                        >
                            <MenuItem value=''><em>— None (write your own) —</em></MenuItem>
                            {templates.map(t => (
                                <MenuItem key={t._id} value={t._id}>
                                    {t.name}{t.modelType ? ` [${t.modelType}]` : ''}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField value={subject} onChange={evt => setSubject(evt.target.value)} margin='dense' label='Subject' fullWidth />

                    {/* Variable input panel */}
                    {detectedVars.length > 0 && (
                        <Paper variant="outlined" sx={{ p: 2, mt: 2, bgcolor: '#f9f9ff' }}>
                            <Typography variant="caption" sx={{ fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1.5 }}>
                                Template Variables
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                                {detectedVars.map(v => (
                                    <TextField
                                        key={v}
                                        size="small"
                                        label={v}
                                        value={variableValues[v] || ''}
                                        onChange={e => handleVarChange(v, e.target.value)}
                                        placeholder={`enter ${v}`}
                                        sx={{ minWidth: 180 }}
                                    />
                                ))}
                            </Box>
                        </Paper>
                    )}

                    <Box sx={{ mt: 2 }}>
                        <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mb: 1 }}>
                            Message Preview (click inside to edit text)
                        </Typography>
                        <Box
                            ref={editorRef}
                            contentEditable
                            suppressContentEditableWarning
                            onInput={handleEditorInput}
                            sx={{
                                border: '1px solid #c4c4c4',
                                borderRadius: 1,
                                minHeight: 'calc(100vh - 420px)',
                                overflow: 'auto',
                                p: 2,
                                backgroundColor: '#fff',
                                outline: 'none',
                                cursor: 'text',
                                '&:focus': { borderColor: '#673ab7', boxShadow: '0 0 0 2px rgba(103,58,183,0.2)' },
                                '&:hover': { borderColor: '#999' },
                                '& img': { maxWidth: '100%', height: 'auto' }
                            }}
                        />
                    </Box>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}



export default function DataTable() {
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
    const [selected, setSelected] = React.useState(null);
    const [refresh, setRefresh] = React.useState(false);
    const [selectedAlert, setSelectedAlert] = React.useState(null);

    const columns = [
        {
            field: 'createdAt', 
            headerName: 'Date', 
            flex: 0.5, 
            valueFormatter: (params) => {
                return new Date(params.value).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
            }
        },
        {
            field: 'subject', 
            headerName: 'Type', 
            flex: 0.5
        },
        {
    field: 'view',
    headerName: 'View',
    flex: 0.2,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
        return (
            <Button
                onClick={(evt) => {
                    evt.stopPropagation();
                    setSelectedAlert(params.row);
                    setSelected(params.row._id);
                }}
                variant="outlined"
            >
                View
            </Button>
        );
    }
}
    ];

    const fetchAlerts = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetAlertsPaginated(params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [refresh])


    return <React.Fragment>
        <PageShell>
            <PageHeader
                title="Alerts"
                back
                onBack={() => navigate('/')}
                actions={
                    <>
                        {Access.isInternal() === true && (
                            <Action
                                primary
                                icon={<AddIcon />}
                                label="Create Notification"
                                onClick={() => setOpen(true)}
                            />
                        )}
                    </>
                }
            />

            <PageContent fill>
                {open && <MessageDialog open={open} handleClose={() => { setOpen(false); setRefresh(!refresh) }} />}
                {selected != null && <DetailsView open={selected != null} handleClose={() => { setSelected(null); setSelectedAlert(null); setRefresh(!refresh) }} item={selectedAlert} />}
                <ResponsiveDataGrid
                    key={refresh}
                    columns={columns}
                    fetchData={fetchAlerts}
                    initialSortModel={[{ field: 'createdAt', sort: 'desc' }]}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                    getRowId={(row) => row._id}
                />
            </PageContent>
        </PageShell>
    </React.Fragment>
}
